<template>

  <div class="h-full flex flex-col justify-center items-center">
    <h2 class="absolute left-9 top-6 font-bold text-lg">Créditos</h2>
    <div>
      <app-in-construction />
    </div>
  </div>

</template>
<script>
import { AppInConstruction } from '@superpagos/mf-custom-components';
export default {
  name: 'SoonView',
  components: { AppInConstruction }
}
</script>
<style lang="scss" scoped>

</style>